export enum ActionsEnum {
    hide = 'HIDE',
    show = 'SHOW',
    edit = 'EDIT',
    delete = 'DELETE',
    copy = 'COPY',
    rename = 'RENAME',
    move = 'MOVE',
    favorite = 'FAVORITE',
    unfavorite = 'UNFAVORITE'
}
